module.exports = __webpack_public_path__ + "static/media/str-group-white.d67b2359.svg";